import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

import { Container, Typography } from "@material-ui/core";
import { Link } from "gatsby-theme-material-ui";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Layout from "../components/Layout";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      alignItems: "center",
      display: "grid",
      // gap: `${theme.spacing(4)}px`,
      justifyItems: "center",
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(2)
    },
    heading: {
      display: "block",
      marginBottom: theme.spacing(2)
    }
  })
);

const NotFoundPage = ({ location }): ReactElement => {
  const classes = useStyles();

  return (
    <Layout pathname={location.pathname}>
      <Container className={clsx(classes.root)} component="main" fluid="fluid">
        <Typography
          className={clsx(classes.heading)}
          component="h1"
          variant="h2"
        >
          Not found
        </Typography>
        <p>You have found a route to a page or post that doesn&#39;t exist.</p>
        <Link to="/">Go to home page</Link>
      </Container>
    </Layout>
  );
};

NotFoundPage.propTypes = {
  location: PropTypes.object
};

export default NotFoundPage;
